// Updated ProfileCompletionScreen.js with the new copy

import React, { useState, useEffect } from "react";
import { Card, CardContent } from "./ui/card";
import { Check, ChevronRight, Loader } from "lucide-react";
import analyticsService from "../lib/AnalyticsService";
import { useInteractionTracking } from "../hooks/useAnalytics";

const ProfileCompletionScreen = ({ userData, onContinue }) => {
  const [loading, setLoading] = useState(true);
  const { trackButtonClick } = useInteractionTracking();
  useEffect(() => {
    analyticsService.trackPageView("profile_complete", {});
  }, []);

  setTimeout(() => {
    setLoading(false);
  }, 2000);
  return (
    <>
      {loading ? (
        <div className="text-center space-y-4">
          <h1 className="text-xl uppercase font-bold">
            Checking Insurance Status
          </h1>
          <p className="text-center text-darkGrey !mt-6">
            This should only take a moment
          </p>
          <div className="flex flex-col items-center justify-center p-8">
            <div className="flex items-center justify-center w-24 h-24 relative">
              <div className="absolute inset-0 flex items-center justify-center">
                <svg
                  className="w-full h-full animate-spin"
                  viewBox="0 0 100 100"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    stroke="#EAE7E7"
                    strokeWidth="13"
                    fill="none"
                  />
                  <path
                    d="M90,50 A40,40 0 0,0 50,10"
                    stroke="#7B61FF"
                    strokeWidth="13"
                    fill="none"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <Loader className="w-8 h-8 text-[#7B61FF] animate-pulse" />
              </div>
            </div>
            <span className="mt-4 text-gray-600">
              Checking for existing policies...
            </span>
          </div>
        </div>
      ) : (
        <div className="space-y-6 p-4 pt-6">
          {/* Header with celebration */}
          <div className="text-center space-y-4">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <Check className="w-10 h-10 text-green-500" />
            </div>
            <h1 className="text-xl font-bold uppercase !mt-6">You Did It!</h1>
            <p className="text-darkGrey !mt-6">
              Congrats on creating your Ownli Insurance Profile!
            </p>
            <p className="text-darkGrey !mt-2">
              We're reviewing it for accuracy and beginning the search for
              potential insurance buyers.
            </p>
          </div>

          {/* Success card with checkmarks for completed steps */}
          {/* <Card className="bg-green-50 border-green-100">
      <CardContent className="pt-6">
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
            <p className="text-sm text-green-700">Insurance information collected</p>
          </div>
          
          <div className="flex items-center gap-2">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
            <p className="text-sm text-green-700">Insurance policy synchronized</p>
          </div>
          
          {userData?.vehicle && (
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
              <p className="text-sm text-green-700">Vehicle data connected</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card> */}

          {/* Continue button with new CTA text */}
          <button
            onClick={() => {
              trackButtonClick("continue", {
                step_name: "profile_complete",
                user_id: userData?.id,
              });
              onContinue();
            }}
            className={`w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient !mt-10 text-white px-4 py-3 rounded-[10px] hover:bg-purpleGradientDark transition-colors`}
          >
            Continue
          </button>
        </div>
      )}
    </>
  );
};

export default ProfileCompletionScreen;
